import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Laapata Ladies`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/00e4644129ab6dccca76cc64d134b3cc/9cea8/laapata-ladies.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAACbUlEQVQozwFiAp39AB9JNDNXRj9cVj5WU09XU15WUmJgWlZeVkZSUUZLTUdQUEZXVURNTFdaWGloa2dnZ1lhX0ZTT0lgWzVhVAApUUC8Z27cfmPbb0vhYUHbZFexXmKzYWnXcljjaULjX0LiZUfbdFTMclbtcD/obEjQalTAXUnYZGFOXVgAKFVIy1FU6Zg365trzHtUYjkjaUArLyooqnVB8ocZ5ngW63EQr4RAeWdCs3kc/5kJtXAZiWVJ62VZVWNhAC1aS8ZbXdZ7RdODdNh7laCBd8B3UmgtH8R5VuxuEOxuGMSIP5p1RbNwUnZQJLR4PHZKJHhOPc9tcF1nYwAnV0nFX1/kXyvWaj35WWnqvLyzrp1sQTaed2fps4m+ezh0by6ebjKbXDxhRRtyUzU3Jx01IA+uT1ZUXloAJ1FEwnJv5lcqniIO30JO752ntbajoqSXhHRqu7isgXxBaVYVo3I+UzUgIyAFUUATLCMWa1A3wHR5UlZSACNSQ8NzePxFVNYuO+BRWf+NodylpNGinp1bWs6BaJ1ROpVTM6pUQYM9M2MnJ4dANY1HR7dkWt93g1haVwAkUD2NZGWqWmKkWV2iW2KRVF+PWmOPV16JVlqTX2WPW2aHVl2HUVeEU1l/U1iGXF6KXF+PX2OQYGJDWk4AIE8+HVZDH1M9HVM7SGs+c4M7dIU+dok+Zn8+dYlFdIxKUHRCdIU9cYdCfI1ATXI/F1hHIV1HFlhFH1dFAB9LOCVVQSNUPyZVQD5mQFBxSVBxTURoRDVjR0BoRkZpQ0JlQUZoQkdqRlByTD9oSipbSixXQypYRCdaSRqK8mnxoLZXAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Film Poster",
            "title": "Film Poster",
            "src": "/static/00e4644129ab6dccca76cc64d134b3cc/c1b63/laapata-ladies.png",
            "srcSet": ["/static/00e4644129ab6dccca76cc64d134b3cc/5a46d/laapata-ladies.png 300w", "/static/00e4644129ab6dccca76cc64d134b3cc/0a47e/laapata-ladies.png 600w", "/static/00e4644129ab6dccca76cc64d134b3cc/c1b63/laapata-ladies.png 1200w", "/static/00e4644129ab6dccca76cc64d134b3cc/9cea8/laapata-ladies.png 1278w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Entertaining funny movie with relatively understated progressive messages.
Props to Kiran Rao's direction and all the actors who made every character stand out.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      